import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  makeStyles,
  Typography,
  Avatar,
  Chip,
  Box,
  Tooltip,
  LinearProgress
} from "@material-ui/core";
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  AccessTime as AccessTimeIcon,
  Message as MessageIcon,
  HourglassEmpty as HourglassEmptyIcon
} from "@material-ui/icons";
import { green, red, orange, blue } from "@material-ui/core/colors";
import moment from "moment";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
  tableContainer: {
    borderRadius: theme.spacing(1),
    width: "100%",
  },
  tableCell: {
    padding: theme.spacing(1),
    whiteSpace: "nowrap",
  },
  headerCell: {
    fontWeight: 600,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.secondary,
  },
  avatarCell: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  avatar: {
    width: 32,
    height: 32,
  },
  statusChip: {
    width: 85,
  },
  onlineChip: {
    backgroundColor: green[100],
    color: green[800],
    fontWeight: 500,
  },
  offlineChip: {
    backgroundColor: red[100],
    color: red[800],
    fontWeight: 500,
  },
  timeInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  ticketCount: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  icon: {
    fontSize: 20,
  },
  tableTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.divider}`,
  }
}));

const TableAttendant = ({ attendants, loading }) => {
  const classes = useStyles();

  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Box className={classes.tableTitle}>
        <Typography variant="h6">
          Lista de Atendentes
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Total Online: {attendants.filter(a => a.online).length}/{attendants.length}
        </Typography>
      </Box>
      
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
              Atendente
            </TableCell>
            <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
              Status
            </TableCell>
            <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
              Atendimentos
            </TableCell>
            <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
              Tempo Médio
            </TableCell>
            <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
              Tempo de Espera
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <LinearProgress />
              </TableCell>
            </TableRow>
          ) : (
            attendants.map((attendant) => (
              <TableRow key={attendant.id}>
                <TableCell className={classes.tableCell}>
                  <Box className={classes.avatarCell}>
                    <Avatar 
                      src={attendant.avatar} 
                      className={classes.avatar}
                    >
                      {attendant.name[0]}
                    </Avatar>
                    <Typography variant="body2">
                      {attendant.name}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Chip
                    icon={attendant.online ? <CheckCircleIcon /> : <CancelIcon />}
                    label={attendant.online ? "Online" : "Offline"}
                    className={`${classes.statusChip} ${
                      attendant.online ? classes.onlineChip : classes.offlineChip
                    }`}
                    size="small"
                  />
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Tooltip title="Tickets em atendimento" arrow>
                    <Box className={classes.ticketCount}>
                      <MessageIcon className={classes.icon} style={{ color: blue[500] }} />
                      <Typography variant="body2">
                        {attendant.tickets || 0}
                      </Typography>
                    </Box>
                  </Tooltip>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Tooltip title="Tempo médio de atendimento" arrow>
                    <Box className={classes.timeInfo}>
                      <AccessTimeIcon className={classes.icon} style={{ color: orange[500] }} />
                      <Typography variant="body2">
                        {attendant.avgSupportTime || "00h 00m"}
                      </Typography>
                    </Box>
                  </Tooltip>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Tooltip title="Tempo médio de espera" arrow>
                    <Box className={classes.timeInfo}>
                      <HourglassEmptyIcon className={classes.icon} style={{ color: orange[500] }} />
                      <Typography variant="body2">
                        {attendant.avgWaitTime || "00h 00m"}
                      </Typography>
                    </Box>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableAttendant; 